module.exports = __webpack_public_path__ + "img/logo_rivieranuragica_v2.631034f3.jpg";